import { render } from "./App.vue?vue&type=template&id=696a19dd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=696a19dd&lang=css"
script.render = render

export default script